import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { PaylinkCustomerInfoResponse } from '../../../store/modules/paylink/types';
import { useLazySearchPaylinkCustomersQuery } from '../../../store/modules/merchant/api';

interface Props {
  merchantId: string;
  customerIdKey: string;
}

/**
 * Small hook to fetch the customer data from the URL query params
 */
export const useURLCustomerFetch = ({ merchantId, customerIdKey }: Props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [initialCustomers, setInitialCustomers] = useState<PaylinkCustomerInfoResponse[]>([]);
  const [searchPaylinkCustomers] = useLazySearchPaylinkCustomersQuery();

  useEffect(() => {
    const customerIds = searchParams.get(customerIdKey as string)?.split(',');
    if (!customerIds || initialCustomers.length > 0) return;

    searchPaylinkCustomers({ merchantId, customerId: customerIds })
      .unwrap()
      .then((res) => {
        const foundCustomers = res.data;
        setInitialCustomers(foundCustomers);
        searchParams.delete(customerIdKey as string);
        if (foundCustomers.length > 0) {
          searchParams.append(
            customerIdKey as string,
            customerIds
              .filter((id) => foundCustomers.some((customer) => customer.payLinkCustomerId === id))
              .join(','),
          );
        }
        setSearchParams(searchParams);
      })
      .catch(() => {
        searchParams.delete(customerIdKey as string);
        setSearchParams(searchParams);
      });
  }, [
    merchantId,
    searchParams,
    initialCustomers.length,
    searchPaylinkCustomers,
    customerIdKey,
    setSearchParams,
  ]);

  return initialCustomers;
};
